import type { Locale } from 'date-fns';
import { fr } from 'date-fns/locale';
import { noop } from 'lodash';
import { createContext, useContext } from 'react';

export type LocaleContextValue = {
  locale: string;
  setLocale: (newLocale: string) => void | Promise<void>;
  messages: Record<string, string>;
  dateFnsLocale: Locale | null;
  isLoading?: boolean;
};

export const LocaleContext = createContext<LocaleContextValue>({
  locale: 'fr',
  setLocale: noop,
  messages: {},
  dateFnsLocale: fr,
  isLoading: false,
});

export const useLocaleContext = () => {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocaleContext must be used within a LocaleProvider');
  }
  return context;
};
